// extracted by mini-css-extract-plugin
module.exports = {"card":"card__3YBiF","inner":"inner__2QZlg","header":"header__5KZaT","goal-text":"goal-text__HNpo8","goal-placeholder":"goal-placeholder__xf5YP"};